import z from "zod";

const eqhoErrorTypeValues = [
  "NOT_IMPLEMENTED",
  "FAILED_TO_PARSE_RESPONSE",
  "START_TIME_MISSING",
  "TO_OR_FROM_NUMBER_MISSING",
  "INVALID_PHONE_CALL",
] as const;

const eqhoErrorTypeSchema = z.enum(eqhoErrorTypeValues);
const EqhoErrorType = eqhoErrorTypeSchema.enum;
type EqhoErrorType = z.infer<typeof eqhoErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type EqhoErrors =
  | {
      errorType: typeof EqhoErrorType.NOT_IMPLEMENTED;
      data: {
        operation: string;
      };
    }
  | {
      errorType: typeof EqhoErrorType.FAILED_TO_PARSE_RESPONSE;
      data: {
        data: unknown;
        parseError: unknown;
      };
    }
  | {
      errorType: typeof EqhoErrorType.START_TIME_MISSING;
      data: {
        input: unknown;
        data: unknown;
      };
    }
  | {
      errorType: typeof EqhoErrorType.TO_OR_FROM_NUMBER_MISSING;
      data: {
        input: unknown;
        data: unknown;
      };
    }
  | {
      errorType: typeof EqhoErrorType.INVALID_PHONE_CALL;
      data: {
        input: unknown;
        parsedPhoneCall: unknown;
      };
    };

export const eqhoErrorDetails: Record<EqhoErrorType, ErrorDetails> = {
  [EqhoErrorType.NOT_IMPLEMENTED]: {
    sentryDescription: "Attempted to call an unimplemented EQHO phone operation",
  },
  [EqhoErrorType.FAILED_TO_PARSE_RESPONSE]: {
    sentryDescription: "Failed to parse EQHO API response",
  },
  [EqhoErrorType.START_TIME_MISSING]: {
    sentryDescription: "Start time is missing from EQHO API response",
  },
  [EqhoErrorType.TO_OR_FROM_NUMBER_MISSING]: {
    sentryDescription: "To or from number is missing from EQHO API response",
  },
  [EqhoErrorType.INVALID_PHONE_CALL]: {
    sentryDescription: "Invalid phone call from EQHO API response",
  },
};
